export default __webpack_public_path__ + "static/media/illustration-recruit-4-w@3x.5ebe5ad8.webp";